export default "__VITE_ASSET__CYgBO20y__"